import { useSelector } from 'react-redux'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import * as publicationOptionValueActions from '@redux/modules/publicationOptionValue'

import defaultState, { requiredFields } from '@models/publicationOptionValue'

const createPublicationOptionValue = (params) => {
  const { publicationOptionValueParams, dispatch, requestOptions } = params
  const { createPublicationOptionValue: createFn } = publicationOptionValueActions

  return dispatch(createFn(publicationOptionValueParams, requestOptions))
}

const deletePublicationOptionValue = (params) => {
  const { publicationOptionValue, dispatch } = params
  const { deletePublicationOptionValue: deleteFn } = publicationOptionValueActions

  return dispatch(deleteFn(publicationOptionValue))
}

export function usePublicationOptionValueForm(publicationOptionValue = {}, options = {}){
  const { validateOn } = options

  const publicationOptionValueForm = useForm(
    defaultState,
    { entity: publicationOptionValue, requiredFields, validateOn },
    [publicationOptionValue.id, publicationOptionValue.cache_key],
  )

  return {
    ...publicationOptionValueForm,
  }
}

const usePublicationOptionValue = (initEntity = {}) => {
  const { entity: publicationOptionValue } = useLatestEntity(initEntity, 'publicationOptionValues')

  const dispatch = useThunkDispatch()

  const creating = useSelector(reduxState => reduxState.publicationOptionValues.creating)

  return {
    callbacks: {
      createPublicationOptionValue: (publicationOptionValueParams, requestOptions) => (
        createPublicationOptionValue({ publicationOptionValueParams, dispatch, requestOptions })
      ),
      deletePublicationOptionValue: () => deletePublicationOptionValue({ publicationOptionValue, dispatch }),
    },
    creating,
    publicationOptionValue,
  }
}

export default usePublicationOptionValue
